// Constant
import { USER_STATUS } from 'constant/shared.constant'

export interface IUserWrapperProps {
  status: USER_STATUS
}

export enum USER_DETAIL_DIALOG_TYPE {
  SEE_USER = 'SEE_USER',
  CHANGE_USER_DATA_DETAIL = 'CHANGE_USER_DATA_DETAIL',
  APPROVE_USER = 'APPROVE_USER',
  REJECT_USER = 'REJECT_USER',
  REMOVE_USER = 'REMOVE_USER',
  CHANGE_ACCOUNT_STATUS = 'CHANGE_ACCOUNT_STATUS',
}

export type TUserDetailDialog = USER_DETAIL_DIALOG_TYPE | ''
